import { render, staticRenderFns } from "./BudgetEditComponent.vue?vue&type=template&id=46a255e3"
import script from "./BudgetEditComponent.vue?vue&type=script&lang=js"
export * from "./BudgetEditComponent.vue?vue&type=script&lang=js"
import style0 from "./BudgetEditComponent.vue?vue&type=style&index=0&id=46a255e3&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports